import { UIComponentState, UIComponentHandler } from '../../../../toolkit/uicomponent';
import * as React from 'react';
import { ToneDto } from '../../../../../core/dto/tonedto';
import { BaseContext } from '../../../../../utils/basecontext';
import { CRBTUIViewImpl } from '../../crbt/crbtuiview';
import { Strings } from '../../../../../utils/resources/strings';
import { PopUpWrapperComponent } from '../../../popup/popupwrappercomponent';
import { GridComponent, GridComponentProps } from '../../../../toolkit/grid/gridcomponent';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../../toolkit/alert/alertcomponent';
import { NoResultComponent } from '../../../nametunes/noresult/noresultcomponent';
import { LoaderComponent } from '../../../../toolkit/loader/loadercomponent';
import { LoaderWrapperComponent } from '../../../popup/loaderwrappercomponent';
import { DedicateFlashMessageToneViewModelImpl } from './dedicateflashmessageviewmodel';
import { DedicateFlashMessageComponentProps, DedicateFlashMessageComponentState } from './dedicateflashmessagecomponent';
import './dedicate-style.css';
import { DedicateFlashMessageCSSStyle } from './dedicateflashmessagecss';
import { RoutingFeatures } from '../../../navigation/routingfeature';
import { DedicateFlashDto } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';

export class DedicateFlashMessageViewImpl extends CRBTUIViewImpl
{
    popUpComponent: PopUpWrapperComponent;
    ref: GridComponent<GridComponentProps<ToneDto>, UIComponentState>;
    private loaderWrapperComponent:LoaderWrapperComponent;

    constructor(private featuredCategoryListViewModel: DedicateFlashMessageToneViewModelImpl,context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
    }

    bindHandlers()
    {
      
        this.closePopup = this.closePopup.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.backClicked = this.backClicked.bind(this);
    }

    getChildComponent(props:DedicateFlashMessageComponentProps,state: DedicateFlashMessageComponentState, cssStyle: DedicateFlashMessageCSSStyle): JSX.Element
    {
        return (
            <>
            
            <div>
             <div id="dedicate-main-div" style={{}}>
                <div id="dedicate-title-div" style={{}}>
                <label id="dedicate-title-label" style={cssStyle.getTitleCSSStyle()}>{props.context.getResources().getString(Strings.dedicate_flash_message)}</label>
                </div>
                <h2 onClick={this.backClicked} id="back-label" style={(cssStyle.getBackCSSStyle())}>{this.getUIProps().context.getResources().getString(Strings.back_arrow)}</h2>
            </div>
            {
                         this.featuredCategoryListViewModel.getListOfDatas().length > 0 &&
              <div id="dedicate-show-more-tonecard-list">
                <GridComponent ref={(item: any) => this.ref = item} listViewModel={this.featuredCategoryListViewModel} context={this.getUIProps().context}/>
             </div>
            }
            <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={this.getUIProps().context}/>
            
           </div>
           {
        state.isDataNotLoaded &&
        <div id="dedicate-no-result">
               <NoResultComponent   context={this.getContext()}/>
        </div>    
      }
       <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
              
           </>
        );
    }

    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.home), this.getUIProps().context.getResources().getString(Strings.flash_message),this.getUIProps().context.getResources().getString(Strings.dedicate_flash_message)];
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    backClicked()
    {
        console.log("backClicked invoked");
        this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.FLASH_MESSAGE, false);
    }
    getBannerImg()
    {
        return "dedicateflashmessage.jpg";
    }
    
    setListOfDatas(listofTones: DedicateFlashDto[])
    {
        this.featuredCategoryListViewModel.setListDatas(listofTones);
    }
    closePopup()
    {
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(false, <></>);
    }
    showPopup(msg:string,type:AlertType):void
    {
        
        this.popUpComponent !== null && this.popUpComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getContext().getResources().getString(Strings.ok)} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
}
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/dedicateflashmessage/dedicateflashmessageview.tsx